export default {
  primary: {
    color: 'light',
    backgroundColor: 'primary',
    border: 'double 3px',
    fontSize: '1rem',
    textTransform: 'uppercase',
    padding: '1rem 3rem',
    fontFamily: 'heading',
    borderColor: 'secondary',
    ':hover': {
      backgroundColor: 'secondary',
      color: 'primary'
    }
  },
  secondary: {
    backgroundColor: 'transparent',
    padding: '1rem 0.5rem',
    color: 'primary',
    border: 'none',
    borderTop: 'solid 1px',
    borderBottom: 'solid 1px',
    borderColor: 'primary',
    borderRadius: '0px',
    fontWeight: 'bold',
    display: 'flex',
    fontSize: '0.85rem',
    ':hover': {
      opacity: '0.4',
      backgroundColor: 'transparent',
      color: 'grey'
    }
  }
}
